import ConfirmationPopup from "lib/ConfirmationPopup";
import React from "react";
import { Button, Spinner } from "react-bootstrap";
import "./index.scss";
import { useState } from "react";
import { getIcon } from "helper/getIcons";
import { useDispatch, useSelector } from "react-redux";
import { bankVerification } from "api/dashboardDetail";
import { setBulkVerifiedResponse } from "redux/dashboardReducer";
const ButtonV1 = (props) => {
  const { label, onClick, className, variant, disabled, confirmation_content, icon_type, custom_style, bulkVerify, verificationType, loading, uae_pass_action } =
    props;

  const organisationInfo = useSelector((state) => state?.loggedInUserInfo?.userAuthInfo?.organisationInfo)


  const [modalShow, setModalShow] = useState(false);
  const dispatch = useDispatch()

  const workflowArr = useSelector((state) => state.dashboardReducer.verificationWorkflows);

  const confirmationWrapper = (confirmation_content) => {
    if (!confirmation_content && !bulkVerify) {
      onClick();
      return;
    } else if (bulkVerify) {
      verifyBankDetails();
      return;
    }
    setModalShow(true);
  };

  const verifyBankDetails = async () => {
    let verificationParams = {
      subwfId: workflowArr,
      verificationType: verificationType,
      organisation_id: "63ec8c5a7afe7b329d0ccc3f", // this is for testing purpose in qa, as pennydrop is only configured in uat, when code is moving to uat, this will be removed and next line uncommented.
      // organisation_id: organisationInfo?._id,
    }

    const result = await dispatch(bankVerification(verificationParams)).unwrap();

    if (result) {
      dispatch(setBulkVerifiedResponse(true))
    }
  }
  return (
    <>
      <Button
        xs={12}
        sm={12}
        onClick={() => confirmationWrapper(confirmation_content)}
        className={`${className} mt-10 ${uae_pass_action === 'Sign_up' && 'Sign_in' ? 'shadow-0':''}  ${icon_type === "fingerprint" ? 'mx-auto fw-bold d-flex align-items-center' : ''} ${custom_style === 'btn-verify' ? 'btn-verify' : ''}`}
        variant={variant}
        disabled={disabled}
      >
        {
          loading &&
          (
            <Spinner className="btn-spinner" size="sm" animation="border" role="status">
              <span className="visually-hidden"></span>
            </Spinner>
          )
        }
        {uae_pass_action === 'Sign_up' ? (
          <img src="https://signdesk.in/company/UAEPASS_Sign_up_Btn_Outline_Active.png" alt="Sign Up" className="button-image" />
        ) : ''}
        {uae_pass_action === 'Sign_in' ? (
          <img src="https://signdesk.in/company/UAEPASS_Sign_in_Btn_Outline_Active.png" alt="Sign In" className="button-image" />
        ): ''}
        {/* {icon_type && getIcon(icon_type,label)} */}
        {icon_type === 'fingerprint' ? '' : label}

        {/* {
          icon_type === "fingerprint" && 
          <p className={`mb-0 mt-1 ${icon_type === 'fingerprint' ? '':'d-none'}`}>
            {label}
          </p>
        } */}
      </Button>
      <ConfirmationPopup
        confirmation_content={confirmation_content}
        show={modalShow}
        onHide={() => setModalShow(false)}
        onFormButtonClick={() => {
          setModalShow(false);
          onClick();
        }}
      />
    </>
  );
};

export default ButtonV1;
